import * as React from "react";
import * as ReactDOM from "react-dom";
import  "./index.css";
import App from "./App";
import FirebaseManager from "./Script/FirebaseManager";

FirebaseManager.initFirebase();

ReactDOM.render(<App />, document.getElementById("root"));
